import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root',
})
export class NotificacaoService {
  constructor(private messageService: MessageService) {}

  notificacaoError(mensagem: string, time: number = 5000) {
    this.messageService.add({
      severity: 'error',
      summary: 'Erro',
      detail: mensagem,
      life: time,
    });
  }

  notificacaoSuccess(mensagem: string, time: number = 5000) {
    this.messageService.add({
      severity: 'success',
      summary: 'Sucesso',
      detail: mensagem,
      life: time,
    });
  }

  notificacaoWarn(mensagem: string, time: number = 5000) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Aviso',
      detail: mensagem,
      life: time,
    });
  }

  notificacaoInfo(mensagem: string, time: number = 5000) {
    this.messageService.add({
      severity: 'info',
      summary: 'Informação',
      detail: mensagem,
      life: time,
    });
  }
}
